import { groupBy } from './Helper';

/**
 * Set of functions that provide data transformation and manipulations for the
 * miEdge retriement API https://github.com/miEdge/retirement_api
 */

/**
 * given the output from the /retirement/plans api returns an array that summarizes
 * each sponsor and provides a count of the plans provided by that sponsor
 *
 * @param {*} retirementPlans
 */

export const summarizeRetirementPlansToSponsors = (retirementPlans) => {
  if (!retirementPlans) {
    console.info('retirementPlans not provided');
    return [];
  }
  // First group the data by carrier
  const sponsors = groupBy(retirementPlans, 'sponsor_name');

  // Map to an array
  const retirementPlansSponsorsList = Object.keys(sponsors).map((sponsor) => {
    return {
      label: `${sponsor} (${sponsors[sponsor].length})`,
      value: sponsor,
      count: sponsors[sponsor].length,
    };
  });

  // Sort alphabetically
  retirementPlansSponsorsList.sort((a, b) => {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  });

  return retirementPlansSponsorsList;
};

/**
 * given the output from the /retirement/service_providers api returns an array that summarizes
 * each sponsor and provides a count of the plans provided by that sponsor
 *
 * @param {*} retirementServiceProviders
 */

export const summarizeRetirementServiceProvidersToSponsors = (retirementServiceProviders) => {
  if (!retirementServiceProviders) {
    console.info('retirementServiceProviders not provided');
    return [];
  }
  // First group the data by carrier
  const sponsors = groupBy(retirementServiceProviders, 'sponsor_name');

  // Map to an array
  const retirementServiceProvidersSponsorsList = Object.keys(sponsors).map((sponsor) => {
    return {
      label: `${sponsor} (${sponsors[sponsor].length})`,
      value: sponsor,
      count: sponsors[sponsor].length,
    };
  });

  // Sort alphabetically
  retirementServiceProvidersSponsorsList.sort((a, b) => {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  });

  return retirementServiceProvidersSponsorsList;
};
